import { CheckCircleIcon } from '@systemeio/ui/icons'

export const StatusCell = ({ isActive, className }: { isActive: boolean; className?: string }) => (
  <CheckCircleIcon
    className={`h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] ${isActive && 'fill-green'} ${
      className || ''
    }`}
  />
)
